import { ScopeElementsConfig } from '../../models/scope-elements-config.interface'
import { ValueDiff } from '../../models/entities-with-changes/value-diff.interface'
import { isNil } from 'lodash'
import { EntityWithChanges } from '../../models/entities-with-changes/entity-with-changes.type'

export function showCrDifferences<T>(config: ScopeElementsConfig, element: EntityWithChanges<T>, fieldName: string) {
  return config?.isChangeRequest && config?.showDiff && isDifferent(element?.changes?.[fieldName])
}

const isDifferent = (value: ValueDiff): boolean => !isNil(value) && value?.new !== value?.old
